/* eslint-disable no-console */

import { fetchJSON } from '@bonnet/core/fetch';
import { logger } from '@bonnet/core/logger';
import cache from '../cache';
import constants from '../constants';
import getReferenceByKey from './getReferenceByKey';
import getReferenceApiPath from './getReferenceApiPath';
const {
  SEARCH_OPTIONS
} = constants;

/**
 * Get name and code attributes for reference data
 * @param {('doorCode' | 'driveGroup' | 'engineCode' | 'extColorGroups' | 'featureCode' | 'fuelTypeGroup' | 'intColorGroups' | 'listingType' | 'location' | 'makeCode' | 'mileageRanges' | 'mpgRange' | 'priceRanges' | 'sellerType' | 'seriesCode' | 'vehicleStyleCode' | 'years' | 'trimCode')} reference data key
 */
export default async function getReference(param, options) {
  let response;
  try {
    let success = false;
    let searchoptions = await cache.get(SEARCH_OPTIONS);
    if (searchoptions) {
      success = true;
    } else {
      // fetch remote reference data
      const searchOptionsResponse = await fetchJSON(getReferenceApiPath(SEARCH_OPTIONS), {
        circuitBreaker: {
          id: 'getReference',
          timeout: 7500,
          fallback: {
            result: {}
          }
        }
      });
      if (searchOptionsResponse.success) {
        success = true;
        searchoptions = searchOptionsResponse.payload;
        cache.put(SEARCH_OPTIONS, searchoptions);
      }
    }

    // return the selected reference data
    const payload = getReferenceByKey(searchoptions, param, options);
    response = {
      success,
      payload
    };
  } catch (error) {
    const {
      message
    } = error;
    if (process.env.NODE_ENV === 'development') {
      logger.log(`[@atc/bonnet-reference/getReference] ${message}`);
    }
    response = {
      success: false,
      message,
      error
    };
  }

  // return the payload
  return response;
}